<template>
    <div>
        <Tabs value="name1"  @on-click="slitTag">
            <div  slot="extra" style="width: 600px">
                <Row>
                    <Col span="12">
                        <Input type="text" style="width: 200px" placeholder="商品名,货号"  v-model.trim="searchNeirong" ></Input>
                        <Button style="margin-left: 5px" @click="search">确定</Button>
                    </Col>
                    <Col span="7" align="right" v-if="isnamewhere==1&&isnamewhere!=3">
                        <Checkbox v-model="allselectcheck">全选上架</Checkbox>
                        <Button style="margin-left: 5px" @click="topShelf(1)">上架</Button>
                    </Col>
                    <Col span="7" align="right"  v-if="isnamewhere==2&&isnamewhere!=3">
                        <Checkbox v-model="allselectcheck">全选下架</Checkbox>
                        <Button style="margin-left: 5px" @click="topShelf(0)">下架</Button>
                    </Col>
                </Row>
            </div>
            <TabPane label="未上架" name="name1" >
               <ul class="box">
                   <li v-for="(item,index) in goodsListL">
                           <div class="thisimgbox">
                               <Fy-Img
                                       class="img"
                                       :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                                       :Width="100"
                                       :Height="100">
                               </Fy-Img>
                               <span v-if="item.tagCode!=null">总</span>
                           </div>
                       <div>
                           <h4>商品名：{{item.name}}</h4>
                           <p>货号：{{item.goodscode}}</p>
                           <p>库存：{{item.num}}</p>
                           <p>￥{{item.lprice}}</p>
                       </div>
                       <Button class="shangjia" v-if="!allselectcheck" type="primary" size="small" @click="topThis(item.id,1)">上架</Button>
                       <Checkbox class="shangjia" v-else v-model="allselectcheck" label=""></Checkbox>
                   </li>
               </ul>
            </TabPane>
            <TabPane label="已上架" name="name2">
                <ul class="box">
                    <li v-for="(item,index) in goodsListL">
                        <div class="thisimgbox">
                            <Fy-Img
                                    class="img"
                                    :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                                    :Width="100"
                                    :Height="100">
                            </Fy-Img>
                            <span v-if="item.tagCode!=null">总</span>
                        </div>
                        <div>
                            <h4>商品名：{{item.name}}</h4>
                            <p>货号：{{item.goodscode}}</p>
                            <p>库存：{{item.num}}</p>
                            <p>￥{{item.lprice}}</p>
                        </div>
                        <Button class="shangjia" v-if="!allselectcheck" type="primary" size="small" @click="topThis(item.id,0)">下架</Button>
                        <Checkbox class="shangjia" v-else v-model="allselectcheck" label=""></Checkbox>
                    </li>
                </ul>
            </TabPane>
            <TabPane label="库存预警" name="name3">
                <ul class="box">
                    <li v-for="(item,index) in yujingListL">
                        <div class="thisimgbox">
                            <Fy-Img
                                    class="img"
                                    :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                                    :Width="100"
                                    :Height="100">
                            </Fy-Img>
                            <span v-if="item.tagCode!=null">总</span>
                        </div>
                        <div>
                            <h4>商品名：{{item.name}}</h4>
                            <p>规格/颜色：{{item.color}}/{{item.size}}</p>
                            <p>当前库存：{{item.num}}</p>
                            <p>库存下线：{{item.warning}}</p>
                        </div>
                    </li>
                </ul>
            </TabPane>
        </Tabs>
        <div class="pageTotal" v-if="ispage">
            <Page  :total="page.total"
                   show-total
                   :page-size="page.rows"
                   @on-change="onChange" />
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                allselectcheck:false, //全选
                isnamewhere:1,
                content:'',//搜索天剑
                select:'name1',
                searchNeirong:'',
                goodsListL:[],
                yujingListL:[],
                ispage:true,
                page:{
                    total:0,
                    page:1,
                    rows:12
                },
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.getGoodsList(this.page.page,this.page.rows,0)
        },
        watch: {
            'searchNeirong': {
                deep: true,
                handler: function (newVal,oldVal){
                    this.search()
                }
            }
        },
        methods: {
            //获取所有商品列表
            getGoodsList(page,rows,isdel){
                this.$Api.getListByGoodsnameOrGoodscode({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows:rows ,
                    condition:this.searchNeirong,//查询内容
                    isdel:isdel
                }).then(res => {
                    if(res.code==200){
                        this.page.total = res.count
                        this.goodsListL = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    this.ispage=true
                }).catch((err)=>{
                    //this.$Message.warning(err.msg);
                    this.goodsListL=[]
                    this.ispage=false
                });
            },
            /*库存预警*/
            getGoodsWarningNum(page,rows){
                this.$Api.getGoodsWarningNum({
                    cid: this.cid,
                    sid: this.sid,
                    condition:this.searchNeirong,
                    page: page,
                    rows: rows,
                }).then(res => {
                    if(res.code==200){
                        this.page.total = res.count
                       this.yujingListL = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //修改分页
            onChange(e){
                this.page.page=e
                if(this.select=='name3'){
                    this. getGoodsWarningNum(this.page.page,this.page.rows)
                }else {
                    if( this.select=='name1'){
                        this.getGoodsList(this.page.page,this.page.rows,0)
                    }else {
                        this.getGoodsList(this.page.page,this.page.rows,1)
                    }

                }
            },
            slitTag(num){
                this.select=num
                this.allselectcheck=false
                if(num=='name1'){
                    this.isnamewhere=1
                    this.getGoodsList(1,12,0)
                }else if(num=='name2'){
                    this.isnamewhere=2
                    this.getGoodsList(1,12,1)
                }else if(num=='name3'){
                    this.isnamewhere=3
                    this.getGoodsWarningNum(1,12)
                }
            },

            //上架
            topThis(id,type){
                this.$Api.putaway({
                    ids: id,
                    isdel: type
                }).then(res => {
                    if(res.code==200){
                        if(type==1){
                            this.$Message.success("上架成功");
                            this.getGoodsList(this.page.page,this.page.rows,0)
                        }else {
                            this.$Message.success("下架成功");
                            this.getGoodsList(this.page.page,this.page.rows,1)
                        }
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            /** 全选上 下 架 **/
            topShelf(num){
                if(this.allselectcheck){
                    var selarr=[]
                    this.goodsListL.forEach((item,index)=>{
                        selarr.push(item.id)
                    })
                    this.$Api.putaway({
                        ids: selarr.join(),
                        isdel: num
                    }).then(res => {
                        if(res.code==200){
                            if(num==1){
                                this.$Message.success("上架成功");
                                this.getGoodsList(this.page.page,this.page.rows,0)
                            }else {
                                this.$Message.success("下架成功");
                                this.getGoodsList(this.page.page,this.page.rows,1)
                            }
                        }else {
                            this.$Message.warning(res.msg);
                        }
                    });
                }



            },




            //搜所
            search(){
                if(this.select=='name1'){
                    this.getGoodsList(1,12,0)
                }else if(this.select=='name2') {
                    this.getGoodsList(1,12,1)
                }else {
                    this.getGoodsWarningNum(1,12)
                }
            }
        }
    };
</script>

<style lang="scss" scoped>

    .box{
        overflow: auto;
        li{
            width:440px;
            height:130px;
            background:rgba(255,255,255,1);
            box-shadow: 0px 0px 10px 0px rgba(24, 54, 129, 0.14);
            border-radius:5px;
            float: left;
            padding-left: 130px;
            padding-top: 15px;
            position: relative;
            margin: 20px 20px 10px;
            line-height: 25px;
            .img{
                width: 100px;
                position: absolute;
                top: 15px;
                left: 15px;
            }
            .shangjia{
                position: absolute;
                right: 0;
                top: 0;
            }
        }
        .checkboxcl{
            position: absolute;
            top: 10px;
            right: 10px;
        }
    }
    .thisimgbox{
        span{
            position: absolute;
            bottom: 15px;
            left:15px;
            padding:0 2px;
            background: #ff5e5e;
            color: #ffffff;
            font-size: 10px;
        }
    }
</style>